
import React, { useState } from 'react';
import { TextInput } from 'flowbite-react';
import { HiEye, HiEyeOff } from 'react-icons/hi';


const PasswordInput = ({
    id,
    name,
    placeholder,
    required,
    value,
    onChange,
    disabled = false,
    inputClasses=""
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    // Combine any passed className with internal padding for the icon

    return (
        <div className="relative">
            <TextInput
                id={id}
                name={name}
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                required={required}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className={inputClasses} 
            />
            <button
                type="button" // Important: prevents form submission
                onClick={togglePasswordVisibility}
                className="absolute inset-y-0 right-0 flex items-center h-full px-3 text-gray-500 hover:text-gray-700 bg-transparent hover:bg-transparent focus:outline-none focus:ring-0 cursor-pointer z-10"
                aria-label={showPassword ? `Hide ${id}` : `Show ${id}`}
            >
                {showPassword ? <HiEyeOff className="h-5 w-5" /> : <HiEye className="h-5 w-5" />}
            </button>
        </div>
    );
};

export default PasswordInput;
